import { useGeckoNotifications } from 'features/notifications'
import { Dispatch, SetStateAction, useCallback } from 'react'

export function useNestedSetter<P, T extends keyof P>(
  setPanelData: React.Dispatch<React.SetStateAction<P>>,
  property: T,
  validator?: (val: P[T]) => boolean
): Dispatch<SetStateAction<P[T]>> {
  const { errorNotification } = useGeckoNotifications()
  return useCallback(
    (val: SetStateAction<P[typeof property]>) => {
      setPanelData((prev) => {
        const callableVal =
          typeof val === 'function' ? (val as (prev: P[T]) => P[T]) : undefined
        const newVal = callableVal ? callableVal(prev[property]) : (val as P[T])
        if (validator && !validator(newVal)) {
          errorNotification(
            `Cannot set ${String(property)} to ${newVal} because it failed validation`
          )
          return prev
        }
        if (newVal === prev[property]) {
          return prev
        }
        const newPd = {
          ...prev,
          [property]: newVal,
        }
        return newPd
      })
    },
    [setPanelData, property, validator, errorNotification]
  )
}
